// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__18OKg","footer":"Form_footer__p4WM3"};